/**
 * Main page implementation.
 *
 * @author Dmytro Fedotov <d.fedotov@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var id           = 'pageLogs',
    Page         = require('stb-component-page'),
    app          = require('mag-app'),
    page         = new Page({$node: document.getElementById(id)}),
    Panel        = require('stb-component-panel'),
    LayoutList   = require('mag-component-layout-list'),
    ModalMessage = require('mag-component-modal'),
    Progress     = require('spa-component-progress-bar'),
    dom          = require('spa-dom'),
    keys         = require('stb-keys'),
    Scroll       = require('stb-component-scrollbar'),
    Flicker      = require('spa-component-flicker'),
    ScrollArea   = require('mag-component-scroll-area'),
    Footer       = require('mag-component-footer'),
    $logsBox     = document.getElementById('plPanelBorders');


page.clock = new Flicker({
    className: 'clock',
    interval: 1000,
    render: function ( $item ) {
        var time  = new Date(),
            hours = time.getHours(),
            mins  = time.getMinutes();

        $item.innerText = (hours > 9 ? hours : '0' + hours) + ':' + (mins > 9 ? mins : '0' + mins);
    }
});
page.add(page.clock);
page.clock.start();


function toogleLogBox () {
    if ( $logsBox.classList.contains('hidden') ) {
        $logsBox.classList.remove('hidden');
        page.footer.init([
            {
                code: keys.f1, title: gettext('Hide log'), action: toogleLogBox
            }, {
                code: keys.menu,
                action: function () {
                    page.middlePanel.blur();
                    page.modalActions.show();
                }
            }
        ]);
    } else {
        $logsBox.classList.add('hidden');
        page.footer.init([
            {
                code: keys.f1, title: gettext('Show log'), action: toogleLogBox
            }, {
                code: keys.menu,
                action: function () {
                    page.middlePanel.blur();
                    page.modalActions.show();
                }
            }
        ]);
    }
}


page.footer = new Footer({
    visible: true,
    parent: page,
    data: [
        {
            code: keys.f1,
            title: gettext('Hide log'),
            action: toogleLogBox
        }, {
            code: keys.menu,
            action: function () {
                page.middlePanel.blur();
                page.modalActions.show();
            }
        }
    ]
});


page.progress = new Progress({
    $node: document.getElementById('plProgressLine'),
    value: 0
});
page.progress.$percents = document.getElementById('plProgressValue');

// middle panel
page.middlePanel = new Panel({
    $node: document.getElementById('plPanel'),
    focusable: true,
    visible: true,
    className: 'middlePanel'
});

page.middlePanel.scroll = new Scroll({});

page.middlePanel.add(
    page.middlePanel.textArea = new ScrollArea({
        propagate: true,
        step: 25,
        scroll: page.middlePanel.scroll,
        events: {
            keydown: function ( event ) {
                console.log('area keydown');
                switch ( event.code ) {
                    case keys.up:
                    case keys.down:
                        this.move(event.code);
                        break;
                }
            }
        }
    }),
    page.middlePanel.scroll
);

page.middlePanel.reset = function () {
    page.middlePanel.textArea.$body.innerHTML = '';
    page.middlePanel.textArea.$body.appendChild(dom.fragment(
        dom.tag(
            'div',
            {className: 'textWrapper'},
            dom.tag('div', {className: 'theme-icon theme-icon-ok'}),
            dom.tag('div', {}, gettext('Prepare update'))
        )
    ));
    page.middlePanel.textArea.show();
    page.middlePanel.textArea.init();
};


// modal message: do something with record
page.modalActions = new ModalMessage({
    visible: false,
    title: gettext('actions'),
    events: {
        show: function () {
            if ( $logsBox.classList.contains('hidden') ) {
                this.children[0].$focusItem.children[0].children[1].innerHTML = gettext('Show log');
            } else {
                this.children[0].$focusItem.children[0].children[1].innerHTML = gettext('Hide log');
            }
            this.focus();
        },
        hide: function () {
            if ( $logsBox.classList.contains('hidden') ) {
                page.focus();
            } else {
                page.middlePanel.textArea.focus();
            }
        }
    },
    children: [
        new LayoutList({
            cycle: true,
            size: 1,
            focusIndex: 0,
            data: [
                {
                    items: [
                        {className: 'theme-icon theme-icon-rc-f1', value: ''},
                        {value: $logsBox.classList.contains('hidden') ? gettext('Show log') : gettext('Hide log')}
                    ],
                    click: function () {
                        toogleLogBox();
                        page.modalActions.hide();
                    }
                }
            ],
            propagate: true
        })
    ]
});
page.add(page.modalActions);

page.modalReload = new ModalMessage({
    title: _('Update error'),
    events: {
        show: function () {
            var self     = this,
                timeLeft = 10;

            this.children[0].focus();
            window.setInterval(function () {
                timeLeft--;
                if ( timeLeft < 0 ) {
                    window.parent.location.reload();
                }
                self.$body.firstChild.firstChild.firstChild.firstChild.children[1].innerText = _('Reload') + ' (' + timeLeft + ')';
            }, 1000);
        },
        hide: function () { page.panelSet.focus(); }
    },
    children: [
        new LayoutList({
            size: 1,
            focusIndex: 0,
            data: [
                {
                    items: [
                        {className: 'theme-icon', value: ''},
                        {value: _('Reload')}
                    ],
                    click: function () { window.parent.location.reload(); }
                }
            ]
        })
    ]
});
page.add(page.modalReload);


page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            if ( !page.blockExit ) {
                app.route(app.pages.info);
            }
            break;
    }
});


app.updater.addListeners({
    progress: function ( data ) {
        console.log('new progress val' + data.now);
        page.progress.set(data.now);
        page.progress.$percents.innerText = data.now + '%';
    },
    stateChange: function ( data ) {
        page.middlePanel.textArea.$body.insertBefore(
            dom.tag(
                'div',
                {className: 'textWrapper'},
                dom.tag('div', {className: 'theme-icon theme-icon-ok'}),
                dom.tag('div', {}, data.now.text)
            ),
            page.middlePanel.textArea.$body.firstChild
        );
        page.middlePanel.textArea.init();
    },
    error: function ( data ) {
        console.log('the end' + data.code);
        page.middlePanel.blur();
        page.modalReload.show();
        //page.blockExit = false;
        //        window.core.notify({
        //            title: _('Update error. Device will be rebooted.'),
        //            icon: 'alert',
        //            type: 'warning'
        //        });
        //        window.setTimeout(function () {
        //            window.parent.location.reload();
        //        }, 5000);
    }
});


page.addListener('show', function ( data ) {
    page.image = data.data;
    page.blockExit = true;
    // kill all applications except this one
    window.core.taskManager.killAll(window);
    //get number of launched applications: Object.keys(core.taskManager.apps).length
    app.updater.start({uri: page.image.url});
    page.middlePanel.reset();
    page.middlePanel.textArea.focus();
});


// public
module.exports = page;
